<div id="fn-time-picker-container">
  <div class="fn-time-picker-search">
    <input class="form-control" [(ngModel)]="value" (input)="durationTimeFn($event)" [disabled]="isDisabled" [placeholder]="placeholder" (keydown)="keydownEvent($event); retrictAlphaCharKeys($event)" />
    <i class=" fn-global-dropdownArrow" [ngClass]="{'fn-open-dropdown': showDropDown,'disable':isDisabled}" (click)="toggleSelect(showDropDown)"></i>
    @if (arrayItemSlots.length > 0 && showDropDown) {
      <ul class="fn-time-picker-ul" id="fn-time-picker-ul" [fnAppendTo]="appendTo" (outsideClick)="closeDropDown()">
        @for (item of arrayItemSlots; track item; let i = $index) {
          <li (mouseover)="activeItem=i" [ngClass]="{'active': activeItem === i  }" (click)="onItemClick()">{{item}}</li>
        }
      </ul>
    }
  </div>
</div>